/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CodeType = {
    Logo: 'logo',
    Python: 'python',
    PythonTurtle: 'python_turtle',
    LogoBlockly: 'logo_blockly',
    PythonBlockly: 'python_blockly',
    PythonTurtleBlockly: 'python_turtle_blockly',
    PybricksBlockly: 'pybricks_blockly',
    Pybricks: 'pybricks',
    Soldered: 'soldered',
    Cpp: 'cpp'
} as const;
export type CodeType = typeof CodeType[keyof typeof CodeType];


export function instanceOfCodeType(value: any): boolean {
    for (const key in CodeType) {
        if (Object.prototype.hasOwnProperty.call(CodeType, key)) {
            if (CodeType[key as keyof typeof CodeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CodeTypeFromJSON(json: any): CodeType {
    return CodeTypeFromJSONTyped(json, false);
}

export function CodeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodeType {
    return json as CodeType;
}

export function CodeTypeToJSON(value?: CodeType | null): any {
    return value as any;
}

export function CodeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CodeType {
    return value as CodeType;
}

